
import { convertToGlobalBlock } from "@/lib/global-blocks/global-blocks";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Dialog from "@/components/UI/Dialog.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";

@Component({ components: { Dialog, TextInput } })
export default class GlobalBlockDialog extends Vue {
  @Prop({ required: true })
  elementId!: number;

  globalBlockName: string | null = "";

  async saveAsGlobalBlock(e: Event) {
    e.preventDefault();

    if (!this.globalBlockName) return;

    if (this.elementId) {
      await convertToGlobalBlock(this.elementId, this.globalBlockName);
    }

    this.globalBlockName = "";
    this.$emit("close");
  }
}
